import {
  IWedding_Website,
  IWedding_Website_Section_GiftListField,
  IWedding_Website_Section_HotelsField,
  IWedding_Website_Section_PhotosField,
  IWedding_Website_Section_QuestionAnswerField,
  IWedding_Website_Section_ScheduleField,
  IWedding_Website_Section_TextField,
  IWedding_Website_Section_VenueField,
  Layout,
} from '@bridebook/models/source/models/Weddings.types';
import { SECTION_NAMES } from '../constants';
import { FontPair } from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/config/font-config';
import { Palette } from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/config/palette-config';

export const venueSection: IWedding_Website_Section_VenueField = {
  data: {
    supplier: '',
    useVenuePhotos: true,
  },
  name: SECTION_NAMES.PRIMARY_VENUE,
  type: 'VenueField',
  visible: true,
};

export const photosSection: IWedding_Website_Section_PhotosField = {
  data: [
    {
      path: 'assets/wedding-websites-imgs/placeholders/placeholder-1.jpg',
      width: 2560,
      height: 1920,
    },
    {
      path: 'assets/wedding-websites-imgs/placeholders/placeholder-2.jpg',
      width: 1760,
      height: 2346,
    },
    {
      path: 'assets/wedding-websites-imgs/placeholders/placeholder-3.jpg',
      width: 1760,
      height: 1760,
    },
  ],
  name: SECTION_NAMES.PRIMARY_PHOTOS,
  type: 'PhotosField',
  visible: true,
};

export const ourStorySection: IWedding_Website_Section_TextField = {
  data: {
    value: '',
  },
  name: SECTION_NAMES.OUR_STORY,
  type: 'TextField',
  visible: true,
};

export const faqSection: IWedding_Website_Section_QuestionAnswerField = {
  data: [],
  name: SECTION_NAMES.FAQ,
  type: 'QuestionAnswerField',
  visible: true,
};

export const giftListSection: IWedding_Website_Section_GiftListField = {
  data: {
    message: '',
    url: '',
  },
  name: SECTION_NAMES.GIFT_LIST,
  type: 'GiftListField',
  visible: true,
};

// Hotels section (stores a single URL)
export const hotelsSection: IWedding_Website_Section_HotelsField = {
  data: {
    message: '',
  },
  name: SECTION_NAMES.HOTELS,
  type: 'HotelsField',
  visible: true,
};

// Empty schedule section (used only for visibility flag)
export const scheduleSection: IWedding_Website_Section_ScheduleField = {
  name: SECTION_NAMES.SCHEDULE,
  type: 'ScheduleField',
  visible: true,
};

export const EMPTY_WEBSITE_TEMPLATE: IWedding_Website = {
  config: {
    theme: {
      font: FontPair.Bridebook,
      palette: Palette.Bridebook,
    },
    rsvpVisible: true,
    layout: Layout.Primary,
  },
  privacy: {
    pin: '',
    published: false,
  },
  sections: [
    photosSection,
    venueSection,
    ourStorySection,
    scheduleSection,
    giftListSection,
    hotelsSection,
    faqSection,
  ],
};
